export type ChatTab = 'all' | 'unread' | 'groups' | 'invites' | 'issuedTickets';

/** The URL owns tab selection, including footer navigation and browser history. */
export function chatTabFromSearch(search: URLSearchParams): ChatTab {
  const tab = search.get('tab');
  return tab === 'unread' || tab === 'groups' || tab === 'invites' || tab === 'issuedTickets'
    ? tab
    : 'all';
}

export function chatTabSearch(search: URLSearchParams, tab: ChatTab): URLSearchParams {
  const next = new URLSearchParams(search);
  if (tab === 'all') next.delete('tab');
  else next.set('tab', tab);
  return next;
}
